const e = { guestSkippedSelf: "{{name}} skipped themselves", hostSkippedGuest: "{{name}} was skipped", failedToSendMessage: "Failed to send message" }, s = {
  session: e
};
export {
  s as default,
  e as session
};
